// extracted by mini-css-extract-plugin
export var alleventsContainer = "index-module--alleventsContainer--z1V9G";
export var eventContent = "index-module--eventContent--sJncx";
export var eventTagsContainer = "index-module--eventTagsContainer--lQgNW";
export var eventsBannerContainer = "index-module--eventsBannerContainer--kGrZU";
export var eventsBannerContent = "index-module--eventsBannerContent--vl7fi";
export var eventsContentContainer = "index-module--eventsContentContainer--E9Wqo";
export var paginationContainer = "index-module--paginationContainer--QcHa8";